import {
  BRAND_LOGO_OPEN,
  BRAND_LOGO_CLOSED,
  BRAND_LOGO_OPEN_INVERTED,
  BRAND_LOGO_CLOSED_INVERTED,
} from './assets'

const DEFAULT_FONT_SIZE = 16
const CHROME_HEIGHTS = {
  topBar: 3.5,
  pageHeader: 8,
  sidebar: 15,
}

const DRAWER_WIDTH = DEFAULT_FONT_SIZE * 15
const DRAWER_WIDTH_CLOSED = DEFAULT_FONT_SIZE * 3.5

const BRAND_PRIMARY = {
  src: BRAND_LOGO_OPEN,
  width: {
    rem: 6.1875,
    px: 99,
  },
  height: {
    rem: 1.5,
    px: 24,
  },
}

const BRAND_PRIMARY_INVERTED = {
  ...BRAND_PRIMARY,
  src: BRAND_LOGO_OPEN_INVERTED,
}

const BRAND_SYMBOL = {
  src: BRAND_LOGO_CLOSED,
  width: {
    rem: 1.5,
    px: 24,
  },
  height: {
    rem: 2,
    px: 32,
  },
}

const BRAND_SYMBOL_INVERTED = {
  ...BRAND_SYMBOL,
  src: BRAND_LOGO_CLOSED_INVERTED,
}
export {
  DEFAULT_FONT_SIZE,
  DRAWER_WIDTH_CLOSED,
  DRAWER_WIDTH,
  BRAND_SYMBOL,
  BRAND_PRIMARY,
  BRAND_PRIMARY_INVERTED,
  BRAND_SYMBOL_INVERTED,
  CHROME_HEIGHTS,
}
